import React from 'react';
import { FaRegEnvelope, FaLinkedinIn } from 'react-icons/fa';

function Footer() {
  const services = [
    { name: 'ENERGY MANAGEMENT', url: '/energy-management' },
    { name: 'EMBEDDED NETWORKS', url: '/embedded-networks' },
    { name: 'ELECTRICAL INFRASTRUCTURE', url: '/infrastructure' },
    { name: 'RENEWABLE SOLUTIONS', url: '/renewables' },
  ];

  const companyLinks = [
    { name: 'OUR STORY', url: '/our-story' },
    { name: 'OUR PEOPLE', url: '/our-people' },
    { name: 'CONTACT US', url: '/contact-us' },
    { name: 'DISCLAIMER', url: '/disclaimer' },
    { name: 'PRIVACY POLICY', url: '/privacy-policy' },
  ];

  return (
    <footer className="bg-[#7ABC32] text-black w-full pt-12 pb-4">
      {/* Main 3-column content area */}
      <div className="w-1/2 mx-auto flex flex-col sm:flex-row sm:justify-between sm:items-start sm:gap-20">
        
        {/* Left Section - Logo and Info */}
        <div className="mb-6 sm:mb-0 sm:w-1/3 flex flex-col items-center sm:items-start">
        <a href="https://www.energyintel.com.au/" target="_blank" rel="noopener noreferrer">
  <img
    src="/assets/images/EI-logo.png"
    alt="Energy Intelligence Company Logo"
    className="w-32 sm:w-24 mb-2"
  />
</a>
          <p className="text-sm mt-2 font-semibold ">Energy Intelligence Pty Ltd</p>
          <p className="text-sm mt-1 mb-4">ACN: 132 080 552</p>
          <div className="flex gap-4">
            <a href="mailto:ops@energyintel.com.au" aria-label="Email">
              <FaRegEnvelope className="w-5 h-5 text-white" />
            </a>
            <a
              href=" https://www.linkedin.com/company/energy-intelligence_2"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn className="w-5 h-5 text-white" />
            </a>
          </div>
        </div>

        {/* Middle Section - Services */}
        <div className="mb-6 sm:mb-0 sm:w-1/3 flex flex-col items-center sm:items-start text-gray-800">
          <h2 className="text-md font-semibold mb-2 ">SERVICES</h2>
          {services.map(({ name, url }) => (
            <a
              key={name}
              href={`https://www.energyintel.com.au${url}`}
              className="text-sm hover:underline mb-2"
              target='_'
            >
              {name}
            </a>
          ))}
        </div>

        {/* Right Section - Company */}
        <div className="sm:w-1/3 flex flex-col items-center sm:items-start text-gray-800">
          <h2 className="text-md font-semibold mb-2">COMPANY</h2>
          {companyLinks.map(({ name, url }) => (
            <a
              key={name}
              href={`https://www.energyintel.com.au${url}`}
              className="text-sm hover:underline mb-2"
              target='_'
            >
              {name}
            </a>
          ))}
        </div>
      </div>

      {/* Bottom aligned with logo section */}
      <div className="w-1/2 mx-auto text-left mt-6">
        <p className="text-sm">
          © 2024 Energy Intelligence. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
